import React, { useState } from 'react';
import styles from './ListManager.module.css';

const ListManager = ({
  title,
  items,
  onRemove,
  onBulkRemove,
  loading,
  label = '',
  description = '',
  inputForm,
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [open, setOpen] = useState(true);

  const handleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };
  const handleSelectAll = () => {
    if (selectedIds.length === items.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(items.map(b => b.id));
    }
  };
  const handleBulkDelete = async () => {
    if (selectedIds.length === 0) return;
    if (!window.confirm(`選択した${label || title}をすべて削除しますか？`)) return;
    await onBulkRemove(selectedIds);
    setSelectedIds([]);
  };

  return (
    <div style={{marginBottom:32}}>
      <div style={{display:'flex',alignItems:'center',fontWeight:'bold',marginBottom:4}}>
        <span style={{flex:1}}>{title}</span>
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          style={{background:'none',border:'none',cursor:'pointer',fontSize:'1.1em',padding:'2px 8px'}}
          aria-label={open ? '閉じる' : '開く'}
        >
          {open ? '▲' : '▼'}
        </button>
      </div>
      <div
        className={open ? styles.listManagerContent : styles.listManagerContentClosed}
        aria-hidden={!open}
      >
        {description && (
          <div style={{marginBottom:8, color:'#555', fontSize:'0.95em'}}>{description}</div>
        )}
        {inputForm && (
          <div style={{marginBottom:8}}>{inputForm}</div>
        )}
        {loading ? (
          <div>読み込み中...</div>
        ) : (
          <>
            <div style={{marginBottom:8}}>
              <label>
                <input type="checkbox" checked={selectedIds.length === items.length && items.length > 0} onChange={handleSelectAll} /> 全選択
              </label>
              <button type="button" className={styles.bulkDeleteButton} disabled={selectedIds.length === 0} onClick={handleBulkDelete}>選択した{label || title}を一括削除</button>
            </div>
            <ul style={{listStyle:'none',padding:0,margin:0}}>
              {items.map((item, idx) => (
                <li key={item.id} style={{display:'flex',alignItems:'center',gap:8,padding:'4px 0',borderBottom:'1px solid #eee'}}>
                  <input type="checkbox" checked={selectedIds.includes(item.id)} onChange={() => handleSelect(item.id)} />
                  <span style={{flex:1}}>{item.name}</span>
                  <button onClick={() => onRemove(idx)} className={styles.deleteButton}>削除</button>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default ListManager;
